<span [class]="cssClass" class="text-start">
  <div class="readmore-text-content" [innerHTML]="formatText(outputText)" [class]="cssClass"></div>
  <span *ngIf="shortened" class="readmore">... <a (click)="expand()" [class]="cssClass">{{"Buyer.ReadMore" |translate}}</a></span>
</span>
